import _ from 'lodash';
import {
  BarChartOutlined,
  DollarOutlined,
  ThunderboltOutlined,
  AccountBookOutlined,
  BarcodeOutlined,
  ProfileOutlined,
  InfoCircleOutlined,
  UserOutlined,
  ClusterOutlined,
  PayCircleOutlined,
} from '@ant-design/icons';

const getItem = (seq, label, key, icon, children) => {
  return { seq, label, key, icon, children };
};

// 篩選符合user.menu的item
export const filterMenus = (data, backendInfo) => {
  const tmpAry = _.cloneDeep(data);
  return tmpAry.filter((item) => {
    let matchedBackendItem = backendInfo.find((backendItem) => {
      return item.key === backendItem.menuPath || item.key.includes(backendItem.menuPath);
    });

    if (matchedBackendItem) {
      item.label = matchedBackendItem.menuName; // 更新 label 屬性
    }

    if (item.children) {
      item.children = filterMenus(item.children, backendInfo);
    }

    return matchedBackendItem || (item.children && item.children.length > 0);
  });
};

export const MenuItems = [
  getItem('1', '專案預算管理', '/budget', <DollarOutlined />, [
    getItem('1-1', null, '/budgetAnalysisReport', null, null),
    getItem('1-2', null, '/budgetDetailReport', null, null), //
    getItem('1-3', null, '/budgetSubItemPoMapping', null, null), //
    getItem('1-4', null, '/budgetSubItemDocumentMapping', null, null), //
    getItem('1-5', null, '/budgetSubItemMaintenance', null, null), //
  ]),
  getItem('2', '會計管理', '/voucher', <AccountBookOutlined />, [
    getItem('2-1', null, '/voucherPrePaymentMapping', null, null),
    getItem('2-2', null, '/voucherPrePaymentMaintenance', null, null),
    getItem('2-3', null, '/voucherContractAssetClosing', null, null),
    getItem('2-4', null, '/settingFixedAssetEntryDept', null, null),
    getItem('2-5', null, '/formAccountsPayableConvertInvoice', null, null),
    getItem('2-6', null, '/prepaidUnpaid', null, null),
  ]),
  getItem('3', '發票管理', '/invoice', <ProfileOutlined />, [
    getItem('3-1', null, '/invoiceIssuance', null, null),
    getItem('3-2', null, '/invoiceQuery', null, null),
  ]),
  getItem('4', '專案代號管理', '/project', <BarChartOutlined />, [
    getItem('4-2', null, '/projectReport', null, null),
    getItem('7-3', null, '/dataSyncProject', null, null),
  ]),
  getItem('5', '採購管理', '/purchase', <BarcodeOutlined />, [
    getItem('5-1', null, '/formRequisitionConvert', null, null),
    getItem('5-2', null, '/queryDeptPurchaseStats', null, null),
  ]),
  getItem('6', '供應商管理', '/supplier', <UserOutlined />, [
    getItem('6-1', null, '/dataSync/SDS', null, null),
    getItem('6-2', null, '/dataCompareSettingCol/SDS', null, null),
    getItem('6-3', null, '/dataCompareSearch/SDS', null, null),
  ]),
  getItem('7', '客戶管理', '/customer', <UserOutlined />, [
    getItem('7-1', null, '/dataSync/CDS', null, null),
    getItem('7-2', null, '/dataCompareSettingCol/CDS', null, null),
    getItem('7-3', null, '/dataCompareSearch/CDS', null, null),
    getItem('7-4', null, '/contactSettings', null, null),
  ]),
  getItem('8', '電站管理', '/electricity', <ThunderboltOutlined />, [
    getItem('8-1', null, '/billCloseAccount', null, null),
    getItem('8-2', null, '/checkoutUpdates', null, null),
    getItem('8-3', null, '/maintenancePaymentForSPV', null, null),
    getItem('8-4', null, '/dailyElectricityReport', null, null),
    getItem('8-5', null, '/electricityBillReview', null, null),
  ]),
  getItem('9', '養殖管理', '/aquaculture', <ClusterOutlined />, [
    getItem('9-1', null, '/aquacultureCostIncomeReport', null, null),
  ]),
  getItem('10', '應付管理', '/payable', <PayCircleOutlined />, [
    getItem('10-1', null, '/paymentStatusQuery', null, null),
  ]),
  getItem('99', '資訊管理', '/itInformation', <InfoCircleOutlined />, [
    getItem('99-1', null, '/accountDeactivation', null, null),
    getItem('99-2', null, '/settingCompanyDatabaseMapping', null, null),
    getItem('99-3', null, '/settingElectricityDetect', null, null),
    getItem('99-4', null, '/settingCalander', null, null),
  ]),
];
